export default __webpack_public_path__ + "static/media/logo.c49e87c2.png";